<a
  *ngIf="viewModel$ | async as vm"
  mat-button
  class="push-right text-nodecoration duty-status"
  [class.duty-status--off-duty]="!vm.onDuty"
  [class.duty-status--on-duty]="vm.onDuty"
  routerLink="{{ vm.url }}"
  [routerLinkActive]="['active']"
>
  <span class="duty-status__status-text">{{ vm.statusText }}</span>
  <span class="duty-status__action-text">{{ vm.actionText }}</span>
</a>
